import { useAppState, useAppDispatch } from '../../Shared/AppContext';

export function useUserIndexState() {
  return useAppState();
}

export function useUserIndexActions() {
  const dispatch = useAppDispatch();

  function initializeState() {
    dispatch((appState) => ({
      ...appState,
      loading: true,
      users: [],
      feedbackMessage: null,
      feedbackVariant: null,
    }));
  }

  function onResponse(response) {
    dispatch((appState) => ({ ...appState, ...response }));
  }

  function onError(feedback) {
    dispatch((appState) => ({ ...appState, ...feedback }));
  }

  function getFeedbackFromLocalStorage(feedbackMessage, feedbackVariant) {
    dispatch((appState) => ({
      ...appState,
      feedbackMessage: feedbackMessage,
      feedbackVariant: feedbackVariant,
    }));
  }

  function clearFeedback() {
    dispatch((appState) => ({
      ...appState,
      feedbackMessage: null,
      feedbackVariant: null,
    }));
  }

  return {
    initializeState,
    onResponse,
    onError,
    getFeedbackFromLocalStorage,
    clearFeedback,
  };
}
